export enum DisabilityActionTypes {
    API_RESPONSE_SUCCESS = '@@disabilities/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@disabilities/API_RESPONSE_ERROR',

    GET_DISABILITIES = '@@disabilities/GET_DISABILITIES',
}
